'use client';

import React, { useState } from 'react';
import AppIcon from '@/core/presentation/components/ui/AppIcon';
import { Button } from '@/core/presentation/components/ui/Button';
import { SectionScreenLayout } from '@/features/app/presentation/components/SectionScreenLayout';
import { FAQ_ITEMS } from '@/features/app/constants/faq';

import { FORM_FIELD_CONTROL_APP, FORM_FIELD_LABEL_APP } from '@/core/presentation/constants/form-field-ui.constants';

const inputClasses = FORM_FIELD_CONTROL_APP;
const labelClasses = FORM_FIELD_LABEL_APP;

export const FAQSuporteSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [enviado, setEnviado] = useState(false);

  const handleSubmitContato = (e: React.FormEvent) => {
    e.preventDefault();
    // UI only – depois: enviar para API de suporte
    setEnviado(true);
    setNome('');
    setEmail('');
    setMensagem('');
  };

  return (
    <SectionScreenLayout
      title="Perguntas e Suporte"
      subtitle="Perguntas frequentes e formulário para falar com a gente."
    >
      <div className="grid lg:grid-cols-2 gap-8 lg:gap-10">
        {/* Coluna 1: FAQ */}
        <section>
          <h2 className="text-sm font-semibold text-navy-dark uppercase tracking-wide mb-4 flex items-center gap-2">
            <AppIcon name="QuestionMarkCircleIcon" size={18} className="text-cyan shrink-0" />
            Perguntas frequentes
          </h2>
          <div className="space-y-2">
            {FAQ_ITEMS.map((faq, i) => (
              <div
                key={i}
                className="rounded-xl border border-border-light bg-white overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between p-4 text-left hover:bg-[#fafbfc] transition-colors"
                  aria-expanded={openIndex === i}
                  aria-controls={`faq-app-answer-${i}`}
                >
                  <span className="text-navy-dark font-medium text-sm pr-3 leading-snug">
                    {faq.question}
                  </span>
                  <span
                    className={`shrink-0 w-8 h-8 rounded-full border border-border-light flex items-center justify-center transition-all duration-200 ${
                      openIndex === i ? 'bg-cyan border-cyan text-navy-dark rotate-45' : 'text-text-muted'
                    }`}
                  >
                    <AppIcon name="PlusIcon" size={18} />
                  </span>
                </button>
                <div
                  id={`faq-app-answer-${i}`}
                  className={`faq-content ${openIndex === i ? 'open' : ''}`}
                >
                  <p className="px-4 pb-4 text-text-muted text-sm leading-relaxed whitespace-pre-line">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Coluna 2: Formulário de contato */}
        <section className="lg:pl-0">
          <h2 className="text-sm font-semibold text-navy-dark uppercase tracking-wide mb-4 flex items-center gap-2">
            <AppIcon name="ChatBubbleLeftRightIcon" size={18} className="text-cyan shrink-0" />
            Falar com o suporte
          </h2>
          <p className="text-sm text-text-muted mb-4">
            Não encontrou sua dúvida? Envie uma mensagem e respondemos no mesmo dia.
          </p>
          {enviado ? (
            <div className="rounded-xl border border-cyan/30 bg-cyan/5 p-5 flex items-center gap-3">
              <AppIcon name="CheckCircleIcon" size={24} className="text-cyan-dark shrink-0" />
              <div>
                <p className="font-medium text-navy-dark">Mensagem enviada!</p>
                <p className="text-sm text-text-muted">
                  Obrigado. Entraremos em contato em breve.
                </p>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmitContato} className="space-y-4">
              <div>
                <label htmlFor="suporte-nome" className={labelClasses}>
                  Nome
                </label>
                <input
                  id="suporte-nome"
                  type="text"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  placeholder="Seu nome"
                  className={inputClasses}
                  required
                />
              </div>
              <div>
                <label htmlFor="suporte-email" className={labelClasses}>
                  E-mail ou WhatsApp
                </label>
                <input
                  id="suporte-email"
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Para entrarmos em contato"
                  className={inputClasses}
                  required
                />
              </div>
              <div>
                <label htmlFor="suporte-mensagem" className={labelClasses}>
                  Mensagem
                </label>
                <textarea
                  id="suporte-mensagem"
                  value={mensagem}
                  onChange={(e) => setMensagem(e.target.value)}
                  placeholder="Descreva sua dúvida ou solicitação..."
                  rows={4}
                  className={`${inputClasses} resize-y min-h-[100px]`}
                  required
                />
              </div>
              <div className="flex justify-end">
                <Button type="submit" size="lg" className="gap-2">
                  <AppIcon name="PaperAirplaneIcon" size={20} />
                  Enviar mensagem
                </Button>
              </div>
            </form>
          )}
        </section>
      </div>
    </SectionScreenLayout>
  );
};
